module.exports = __webpack_public_path__ + "static/media/review-cookie-top.9b60f723.png";